import * as React from 'react';
import Tag from 'antd/lib/tag';
import Select from 'antd/lib/select';
import { connect } from 'react-redux';
import { CommonProps } from './common.intefaces';
import { ShippingLine } from 'src/Library/Types';
import { ModesOfService } from 'src/Library/Constants';

interface IProps extends CommonProps {
  carriers: ShippingLine [];
  type: ModesOfService,
}

const ShippingLineSelect = (props: IProps) => {

  const {
    mode,
    style,
    value,
    type,
    onChange,
    className,
    carriers,
    disabled,
    placeholder,
  } = props;

  const renderOrgOptions = () => {
    const lines = carriers?.filter(carrier => {
      if (type === ModesOfService.AIRCARGO) {
        return carrier.type === ModesOfService.AIR;
      }
      return carrier.type === 'SEA';
    });
    return lines?.map((shippingLine: ShippingLine) => <Select.Option
      {...shippingLine}
      key={shippingLine.id}
      value={shippingLine.id}
      data-value={shippingLine.name}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {shippingLine.name}
        {!shippingLine.isTrackingEnabled && <Tag color="cyan">Manual</Tag>}
      </div>
    </Select.Option>) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    // labelInValue
    value={value}
    disabled={disabled}
    onChange={onChange}
    optionLabelProp="data-value"
    className={className}
    filterOption={(inputValue, option) => {
      if (!inputValue) return true;
      const optionval = option.props['data-value'] ?
        option.props['data-value'].trim().toLowerCase() : '';
      return optionval.includes(inputValue.trim().toLowerCase());
    }}
    mode={mode || 'default'}
    dropdownMatchSelectWidth={false}
    placeholder={placeholder || 'Select Shipping Line(s)'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderOrgOptions()}
  </Select>;
};

const mapStateToProps = ({ masterData }, ownPros) => ({
  carriers: masterData.globalCarriers,
});

export default React.memo(connect(mapStateToProps)(ShippingLineSelect));
